`<template>
  <div>
    <div
      class="card d-md-inline-flex flex-lg-row h-100 my-3 p-0 b-0 rounded-0 box-shadow"
    >
      <i
        class="d-lg-none fas fa-ellipsis-v position-absolute p-3 text-muted handle p-2"
      ></i>
      <div class="card-header border-0 p-3 bg-white">
        <div class="text-center">
          <div>
            <img :src="getImageSource(image)" class="card-image" />
            <p
              v-if="!isArchived"
              class="d-flex align-items-center justify-content-center bg-dark card-text text-white bg-dark p-1"
            >
              {{ fakeIndex }}
            </p>
          </div>
        </div>
        <div
          class="d-sm-flex d-lg-none justify-content-center align-items-center text-center mt-3"
        >
          <button
            v-if="isArchived"
            type="button"
            class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
            @click="restoreImage(image)"
          >
            Restore
          </button>
          <button
            v-if="!isArchived"
            type="button"
            data-toggle="modal"
            data-target="#image-editor"
            data-backdrop="true"
            class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
            @click="showModal = true"
          >
            Edit
          </button>
          <button
            v-if="!isArchived"
            type="button"
            class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
            @click="deleteImage(image)"
          >
            Delete
          </button>
        </div>
      </div>
      <hr class="d-sm-flex d-lg-none my-2 mx-0" />

      <div class="card-body align-self-lg-center">
        <small v-if="isArchived" class="text-muted"
          >Archived {{ archiveLength }}</small
        >
        <div class="d-none d-md-none d-lg-flex align-items-center pb-3">
          <button
            v-if="!isArchived"
            type="button"
            data-toggle="modal"
            data-target="#image-editor"
            data-backdrop="true"
            class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
            @click="showModal = true"
          >
            Edit
          </button>

          <button
            v-if="!isArchived"
            type="button"
            class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
            @click="deleteImage(image)"
          >
            Delete
          </button>
          <input
            type="checkbox"
            class="align-self-center"
            v-show="bulkSelect"
            :value="image.id"
            @click="selectImage(image)"
          />
          <button
            v-if="isArchived"
            type="button"
            class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
            @click="restoreImage(image)"
          >
            Restore
          </button>
          <transition name="fade">
            <span key="1" v-if="loading"
              ><i class="fas fa-circle-notch fa-spin"></i
            ></span>
            <span
              key="2"
              v-else
              data-toggle="tooltip"
              data-placement="top"
              title="Uploaded!"
              ><i class="fas fa-check text-success"></i
            ></span>
          </transition>
          <i
            v-if="!isArchived"
            class="fas fa-ellipsis-v ml-auto text-muted handle p-2"
            data-toggle="tooltip"
            data-placement="top"
            title="Sort Image"
          ></i>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <small class="text-muted">Stock: {{ stockNumber }}</small>
          <a
            class="download text-dark text-decoration-none d-none d-lg-block p-1"
            target="_blank"
            :href="image.BlobImageUrl"
            @click.prevent="downloadImage(image)"
            data-toggle="tooltip"
            data-placement="top"
            title="Download"
          >
            <i class="fas fa-download"></i>
          </a>
        </div>
      </div>
    </div>
    <PhotoEditor
      :openModal="showModal"
      @modal="showModal = $event"
      :image="image"
      @updateImagePreview="displayCroppedImage"
    />
  </div>
</template>


<script>
import PhotoEditor from "@/components/PhotoEditor.vue";
import UploaderMixins from "../mixins/UploaderMixins.js";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import axios from "axios";
//import { saveAs } from "file-saver";

export default {
  name: "ImageCard",
  mixins: [UploaderMixins],
  components: {
    PhotoEditor,
  },
  props: {
    image: {
      type: Object,
      default: null,
    },
    selectedMachine: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      defualt: null,
    },
    bulkSelect: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isArchived: {
      type: Boolean,
    },
  },
  data() {
    return {
      showModal: false,
      croppedImage: "",
    };
  },
  computed: {
    fakeIndex() {
      return this.index + 1;
    },
    stockNumber() {
      return this.selectedMachine
        ? this.selectedMachine.StockNumber
        : this.image.StockNumber;
    },
    archiveLength() {
      dayjs.extend(relativeTime);
      var now = dayjs();
      const imageDeleted = dayjs(this.image.DateDeletedOn);
      return imageDeleted != now ? imageDeleted.from(now) : now;
    },
  },
  methods: {
    downloadImage(image) {
      axios
        .get(image.BlobImageUrl, {
          responseType: "blob",
        })
        .then((response) => {
          if (response) {
            var FileSaver = require("file-saver");
            FileSaver.saveAs(
              new Blob([response.data]),
              image.StockNumber + ".jpg"
            );
          }
        });
    },
    displayCroppedImage(image) {
      if (image) {
        this.croppedImage = image;
      }
    },
    selectImage(image) {
      this.$emit("updateSelectedImage", image);
    },
    deleteImage(image) {
      this.$emit("deleteSelectedImage", image);
    },
    restoreImage(image) {
      this.$emit("restoreArchivedImage", image);
    },
  },
  watch: {
    selectedMachine: {
      handler: function () {
        return this.selectedMachine && this.selectedMachine.StockNumber
          ? this.selectedMachine.StockNumber
          : this.image.StockNumber;
      },
    },
    showModal: {
      handler: function () {
        this.$emit("disableDraggableCards", this.showModal);
      },
    },
  },
};
</script>